import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFormatById from "src/hooks/utils/useFormatById";
import actions from "src/store/privacyPolicies/actions";

const PrivacyStatement = () => {
  const f = useFormatById();
  const dispatch = useDispatch();

  // const privacyPolicy = useSelector(state => state.privacyPolicies.privacyPolicy)

  // useEffect(()=>{
  //   dispatch(actions.getPrivacyPolicies())
  // },[])

  // useEffect(() => {
  //   console.log(privacyPolicy)
  // }, [privacyPolicy])

  return (
    <div className="container">
      <div className="mt-3">
        <h1 className="text-center mb-3">{f("breadCrumb.privacyStatement")}</h1>
        <div className="mb-5">
          სს „სადაზღვევო კომპანია იმედი ელ“ („ჩვენ“ ან/და „კომპანია“) მადლობას
          გიხდით, რომ ეწვიეთ ჩვენს ვებგვერდს და დაინტერესდით ჩვენი მომსახურებითა
          და პროდუქტებით.
          <br />
          <br />
          გაცნობებთ, რომ პატივს ვცემთ თქვენი პირადი ცხოვრებისა და პერსონალური
          მონაცემების დაცვის უფლებებს. ჩვენთვის პრიორიტეტულია, თქვენი მონაცემები
          დავამუშაოთ კონფიდენციალურობის დაცვის საუკეთესო პრაქტიკისა და მოქმედი
          კანონმდებლობის შესაბამისად.
          <br />
          <br />
          გამომდინარე იქედან, რომ პასუხისმგებლობით ვეკიდებით თქვენი მონაცემების
          დაცვას და გვსურს გამჭვირვალედ წარვმართოთ მონაცემთა დამუშავების
          პროცესი, წინამდებარე განაცხადით აღვწერთ თუ რა მონაცემებს ვაგროვებთ,
          როგორ, რა მიზნით და საშუალებებით ვამუშავებთ მათ და გაგაცნობთ თქვენს
          უფლებებსა და მათი რეალიზების მექანიზმებს.
          <br />
          <br />
          განაცხადში გამოყენებულ ტერმინებს აქვთ „პერსონალურ მონაცემთა დაცვის
          შესახებ“ საქართველოს კანონით და სხვა ნორმატიული აქტებით განსაზღვრული
          მნიშვნელობა
        </div>
        <div className="mb-5">
          <h4 className="mb-2">
            ვინ არის პასუხისმგებელი თქვენი მონაცემების დამუშავებაზე?
          </h4>
          <span className="fw-bold">
            კომპანიის სრული სახელწოდება და პროფილი:
          </span>{" "}
          სს „სადაზღვევო კომპანია იმედი ელ“, ს/ნ: 204919008 - საქართველოს
          კანონმდებლობის საფუძველზე შექმნილი და მოქმედი სადაზღვევო კომპანიაა.
          მისი ძირითადი საქმიანობაა სადაზღვევო მომსახურების გაწევა და უმთავრესად
          ჯანმრთელობისა და მასთან დაკავშირებული რისკების დაზღვევაზეა
          ორიენტირებული.
          <br />
          <br />
          მისამართი და საკონტაქტო მონაცემები: ანა პოლიტკოვსკაიას ქუჩა 9,
          თბილისი, 0131, საქართველო; ტელ:{" "}
          <a href="tel:+995322922222">+995 322 92 22 22;</a> ელ. ფოსტა:{" "}
          <a href="mailto:info@imedil.ge">info@imedil.ge</a>,{" "}
          <a href="mailto:personaldataofficer@imedil.ge">
            personaldataofficer@imedil.ge
          </a>
          <br />
          <br />
          ამ განაცხადთან ან/და კომპანიის მიერ პერსონალურ მონაცემთა დამუშავების
          პრაქტიკასთან დაკავშირებით კითხვების შემთხვევაში, დაგვიკავშირდით:
          <br />
          <br />
          <span className="fw-bold">პერსონალურ მონაცემთა დაცვის ოფიცერი</span> ი
          - შპს “Privacy Professionals“ (ს/ნ: 405682916); ტელ.: 577 070 591; 599
          900 215; ელ. ფოსტა:{" "}
          <a href="mailto:privacyprofessionalsgeo@gmail.com">
            privacyprofessionalsgeo@gmail.com
          </a>
        </div>

        <div className="mb-5">
          <h4 className="mb-2">რა მონაცემებს ვამუშავებთ?</h4>
          ჩვენ, როგორც სადაზღვევო კომპანიას, საქართველოს მოქმედი კანონმდებლობის
          შესაბამისად, გვესაჭიროება ინფორმაცია დაზღვევის ხელშეკრულების
          გასაფორმებლად და აღნიშნულ ინფორმაციას ჩვენ ვღებულობთ უშუალოდ თქვენგან.
          ამგვარი მონაცემები 2 | 1 0 როგორც წესი, არ არის საჯაროდ ხელმისაწვდომი.
          კომპანიის მიერ დამუშავებული მონაცემების კატეგორია დამოკიდებულია
          შემოთავაზებული დაზღვევის ტიპზე და შესაძლოა მოიცავდეს ქვემოთ
          ჩამოთვლილს:
          <br />
          <br />
          <ul>
            <li>
              სახელს, გვარს, მისამართს, სამუშაო ადგილს, საკონტაქტო ინფორმაციას,
              დაზღვევის ობიექტს.
            </li>
            <li>
              ადამიანური რესურსების ადმინისტრირებისთვის გათვალისწინებული
              პერსონალური ინფორმაცია, რომელიც ეხება კომპანიაში დასაქმებულებსა და
              დასაქმების მსურველებს. ეს მოიცავს შერჩევის ორგანიზების, დასაქმების
              და შრომითი ხელშეკრულების შეწყვეტის დროს მოპოვებულ ინფორმაციას.
            </li>
            <li>
              IP მისამართი, რომლის გამოყენებაც ხორციელდება ვებ-გვერდებზე და
              სადაც ხდება თქვენთვის შემოთავაზებული მომსახურების რეალიზაცია,
              ვებ-გვერდზე თქვენი ვიზიტის თარიღი და დრო; ვებ-გვერდზე თქვენი
              სესიის ხანგრძლიობა; ვებგვერდზე განხორციელებული ქმედებების შესახებ
              ინფორმაცია, მათ შორის თქვენ მიერ შევსებული სხვადასხვა განაცხადი თუ
              ველი, მათი შევსების პროცესი და შესავსებად გამოყენებული დრო.
              გვერდები, რომლებიც ვებ-გვერდზე გახსენით მისით სარგებლობისას;
              თქვენი ვიზიტების რაოდენობა ჩვენს ვებ-გვერდზე ნებისმიერი თვის
              განმავლობაში; იმ ფაილის URL, რომელსაც ნახულობთ, და მასთან
              დაკავშირებული ინფორმაცია; გვერდი, რომელმაც გადმოგამისამართათ ჩვენს
              ვებგვერდზე; საოპერაციო სისტემა, რომელსაც იყენებს თქვენი
              კომპიუტერი; ჩვენს ვებგვერდზე არსებულ „ტრაფიკზე“ თვალის მიდევნების
              მიზნით ვიყენებთ სხვადასხვა ანალიტიკურ მომსახურებას)
            </li>
            <li>
              გარდა ამისა, შესაძლოა ასევე თქვენგან გამოთხოვილ და დამუშავებულ
              იქნეს ისეთი{" "}
              <span className="fw-bold">
                განსაკუთრებული კატეგორიის პერსონალური მონაცემები
              </span>
              , რომლებიც დაკავშირებულია თქვენს ჯანმრთელობასთან, ფიზიკურ
              მდგომარეობასთან, მათ შორის: კონკრეტულ დაავადებებთან დაკავშირებით
              სიმპტომების არსებობა, გადატანილი/არსებული დაავადებები. ასევე,
              ინფორმაცია თქვენთვის გაწეული მომსახურებისა და თქვენ მიერ
              კომპანიისგან მიღებული პროდუქტების შესახებ, თქვენთან კომუნიკაციის
              შედეგად მოპოვებული მონაცემები და ნებისმიერი სხვა ინფორმაცია,
              რომლის დამუშავების ვალდებულება გვეკისრება კანონმდებლობით.
            </li>
            <li>
              ჩვენ მიერ დამუშავებული მონაცემების შეგროვება აუცილებელია
              საკანონმდებლო თუ ხელშეკრულებით ნაკისრი ვალდებულებების
              უზრუნველსაყოფად და მოიცავს ასევე განსახორციელებელ და
              განხორციელებულ გადახდებს, გადახდის ფორმას (უნაღდო ანგარიშსწორების
              შემთხვევაში, საბანკო რეკვიზიტებს), თქვენს მიერ არჩეულ სადაზღვევო
              პაკეტს, დაფარვის ტერიტორიას, ლიმიტებს და სადაზღვევო პრემიის
              ოდენობას. მონაცემთა შეგროვებისას შეგატყობინებთ თუ რა მონაცემებია
              სავალდებულოდ მოსაწოდებელი და რა შედეგები შეიძლება დადგეს მათი
              მოუწოდებლობის შემთხვევაში.{" "}
            </li>
          </ul>
          <br />
          ჩვენ ინფორმაციას ვაგროვებთ უშუალოდ თქვენგან, როდესაც საკუთარი ნებით
          გვაწვდით მაგალითად, სადაზღვევო პროდუქტებით სარგებლობისთვის განაცხადის
          შევსების გზით. ასევე, ვაგროვებთ სხვა წყაროებიდანაც. მაგალითად, საჯარო
          წყაროებიდან, დაზღვევის 3 | 1 0 ბროკერების, ჯანდაცვის დაწესებულებების,
          ფინანსური ინსტიტუტების მიერ მოწოდებული ინფორმაციის ფარგლებში.
        </div>

        <div className="mb-5">
          <h4 className="mb-2">მონაცემთა დამუშავების მიზნები</h4>
          მნიშვნელოვანია, რომ კანონმდებლობით განსაზღვრული პრინციპების
          შესაბამისად, ჩვენთან მონაცემები მუშავდება მხოლოდ იმ მიზნით, რისთვისაც
          მას გადმოგვცემთ. ამასთან, ჩვენი დასაქმებულები და კონტრაქტორები,
          რომელთაც თავიანთი კომპეტენციის ფარგლებში, წვდომა აქვთ გარკვეული
          კატეგორიის პერსონალურ მონაცემებთან, მათთან გაფორმებული ხელშეკრულების
          საფუძველზე, შებოჭილნი არიან მონაცემთა კონფიდენციალურად შენახვისა და
          არასანქცირებული გამჟღავნებისაგან თავის შეკავების ვალდებულებით. გარდა
          ამისა, ორგანიზაციაში სპეციალურ პროგრამაზე არსებული ლოგირების სისტემა,
          ყოველი თანამშრომლისთვის უზრუნველყოფს ინფორმაციაზე დაშვებას მისთვის
          დაკისრებული მოვალეობების ფარგლებში.
          <br />
          <br />
          ამასთან, თქვენი მონაცემები მუშავდება მხოლოდ იმ მოცულობით, რომელიც
          აუცილებელია კანონიერი მიზნის მისაღწევად და მხოლოდ იმ ვადით, რაც
          აუცილებელია, მონაცემების დამუშავების მიზნის მისაღწევად.
          <br />
          <br />
          თქვენი პერსონალური მონაცემები შესაძლოა დამუშავდეს შემდეგი მიზნით
          (აღნიშნული ჩამონათვალი არ არის ამომწურავი):
          <ul>
            <li>
              სადაზღვევო მომსახურების გაწევა და სახელშეკრულებო ვალდებულებების
              შესრულება;
            </li>
            <li>
              სადაზღვევო მომსახურების შეთავაზება, პირდაპირი მარკეტინგის
              განხორციელება, მომსახურების გაუმჯობესება, თქვენ მიერ
              ვალდებულებების შესრულების მონიტორინგის მიზნებისათვის;
            </li>
            <li>
              თქვენ მიერ ვებ-გვერდზე განხორციელებული ვიზიტის შესახებ ინფორმაციის
              შეგროვება, მათ შორის ვებ-გვერდზე თქვენი ქცევის შესასწავლად, თქვენ
              მიერ გაკეთებული არჩევანის დასამახსოვრებლად, მოძიებული ინფორმაციის
              ანალიზისათვისა და შემდგომში თქვენზე მორგებული/პერსონალური
              შეთავაზებების განსახორციელებლად;
            </li>
            <li>
              ვებ-გვერდზე არსებული სხვადასხვა საკომუნიკაციო საშუალებით ჩვენთვის
              დატოვებულ შეტყობინებებზე რეაგირების მიზნით; თქვენთვის
              საჭიროებისამებრ შეტყობინებების/კორეპონდენციების გადმოსაგზავნად;{" "}
            </li>
            <li>თქვენზე დაცული პერსონალური მონაცემების განახლება, შეცვლა;</li>
            <li>სადაზღვევო შემთხვევის დადგენა, მისი მოცულობის განსაზღვრა;</li>
            <li>სადაზღვევო შემთხვევის შედეგად დამდგარი ზარალის რეგულირება;</li>
            <li>სადაზღვევო ანაზღაურების გაცემა</li>
            <li>
              სადაზღვევო საქმიანობის აგენტის და ბროკერის მეშვეობით
              განხორციელება;
            </li>
            <li>
              თანამშრომელთა და მათი ოჯახის წევრების ჯანმრთელობის დაზღვევით
              უზრუნველყოფა;
            </li>
            <li>კანონმდებლობით დაკისრებული ვალდებულების შესრულება;</li>
            <li>
              ჩვენ მიერ განსაზღვრული სხვადსხვა მიზნებისათვის კვლევების
              განხორციელება, რეპორტების/ანგარიშების შედგენა;
            </li>
            <li>
              სახელშეკრულებო ურთიერთობების ფარგლებში ნაკისრი უფლება-მოვალეობების
              შესრულება;
            </li>
            <li>საჩივრების/პრეტენზიების განხილვა და მათზე რეაგირება;</li>
            <li>
              ჩვენი ზედამხედველი ორგანოსათვის და აუდიტორული კომპანიებისათვის
              მონაცემთა ხელმისაწვდომობის უზრუნველსაყოფა;
            </li>
            <li>კანონმდებლობით გათვალისწინებული ვალდებულებების შესრულება</li>
          </ul>
        </div>
        <div className="mb-5">
          <h4 className="mb-2">მონაცემთა დამუშავების საფუძველი</h4>
          „კომპანიაში“ თქვენი პერსონალური მონაცემები მუშავდება მხოლოდ შესაბამისი
          საფუძვლის არსებობის შემთხვევაში. მონაცემთა დამუშავების დროს შესაძლოა
          არსებობდეს ერთი ან ერთდროულად რამდენიმე საფუძველი.
          <br />
          <br />
          ჩვენ მიერ პერსონალური მონაცემების დამუშავება ხორციელდება შემდეგი
          საფუძვლების არსებობისას:
          <ul>
            <li>
              არსებობს მონაცემთა სუბიექტის, თქვენი ნებაყოფლობითი თანხმობა
              მონაცემთა ერთი ან რამდენიმე კონკრეტული მიზნით დამუშავებაზე,
              რომელიც შესაძლოა გამოხატული იყოს, როგორც წერილობითი, ისე ზეპირი,
              სატელეკომუნიკაციო, ელექტრონული ან სხვა შესაბამისი ფორმით;
            </li>
            <li>
              მონაცემთა დამუშავება აუცილებელია მონაცემთა სუბიექტთან დადებული
              გარიგებით ნაკისრი ვალდებულების შესასრულებლად ან მონაცემთა
              სუბიექტის მოთხოვნით გარიგების დასადებად;
            </li>
            <li>მონაცემთა დამუშავება გათვალისწინებულია კანონით;</li>
            <li>
              მონაცემთა დამუშავება საჭიროა კომპანიის მიერ მისთვის კანონმდებლობით
              დაკისრებული მოვალეობების შესასრულებლად;
            </li>
            <li>
              მონაცემები კანონმდებლობის თანახმად საჯაროდ ხელმისაწვდომია ან
              მონაცემთა სუბიექტმა იგი საჯაროდ ხელმისაწვდომი გახადა;
            </li>
            <li>
              მონაცემთა დამუშავება საჭიროა მონაცემთა სუბიექტის ან სხვა პირის
              სასიცოცხლო ინტერესების დასაცავად;
            </li>
            <li>
              მონაცემთა დამუშავება აუცილებელია მნიშვნელოვანი საჯარო ინტერესის
              დასაცავად;
            </li>
            <li>
              მონაცემთა დამუშავება აუცილებელია საქართველოს კანონმდებლობით
              განსაზღვრული საჯარო ინტერესის სფეროსათვის მიკუთვნებული ამოცანების
              შესასრულებლად;
            </li>
            <li>
              მონაცემთა დამუშავება აუცილებელია კომპანიის ან მესამე პირის
              მნიშვნელოვანი ლეგიტიმური ინტერესების დასაცავად, გარდა იმ
              შემთხვევისა, თუ არსებობს მონაცემთა სუბიექტის (მათ შორის,
              არასრულწლოვანის) უფლებების დაცვის აღმატებული ინტერესი;
            </li>
            <li>
              მონაცემთა დამუშავება აუცილებელია კანონის შესაბამისად მნიშვნელოვანი
              საჯარო ინტერესის დასაცავად;
            </li>
            <li>
              მონაცემთა დამუშავება აუცილებელია მონაცემთა სუბიექტის განცხადების
              განსახილველად და მისთვის მომსახურების გასაწევად.
            </li>
          </ul>
          <br />
          <br />
          თქვენი განსაკუთრებული კატეგორიის მონაცემთა დამუშავება ხდება მხოლოდ იმ
          პირობებში, რომ უზრუნველყოფილია თქვენი უფლებებისა და ინტერესების დაცვის
          საქართველოს კანონმდებლობით გათვალისწინებული გარანტიები და არსებობს
          მონაცემთა სუბიექტის წერილობითი თანხმობა ერთი ან რამდენიმე კონკრეტული
          მიზნით განსაკუთრებული კატეგორიის მონაცემთა დამუშავებაზე. <br />
          <br />
          გარდა აღნიშნულისა, თქვენი განსაკუთრებული მონაცემები ჩვენ მიერ
          შესაძლებელია დამუშავდეს იმ შემთხვევაში, თუ მათი დამუშავება პირდაპირ და
          სპეციალურად რეგულირდება კანონით და მათი დამუშავება არის აუცილებელი და
          პროპორციული ზომა დემოკრატიულ საზოგადოებაში, ასევე თუკი მათი დამუშავება
          აუცილებელია თქვენი ან სხვა პირის სასიცოცხლო ინტერესების დასაცავად,
          სოციალური უზრუნველყოფისა და სოციალური დაცვის სფეროში, მათ შორის,
          სოციალური უზრუნველყოფის სისტემისა და მომსახურების მართვისთვის
          საქართველოს კანონმდებლობით დამუშავებისთვის პასუხისმგებელი
          პირისთვისდაკისრებული მოვალეობის შესასრულებლად ან მონაცემთა სუბიექტის
          კონკრეტული უფლებების განსახორციელებლად და კანონმდებლობით
          გათვალისწინებულ სხვა შემთხვევებში.
        </div>

        <div className="mb-5">
          <h4 className="mb-2">ავტომატიზებული გადაწყვეტილებები</h4>
          სადაზღვევო რისკების შეფასებისას ან თაღლითობის პრევენციის მიზნით
          გასატარებელი ღონისძიებები შესაძლოა მოიცავდეს პროფილირებასაც, რაც
          გულისხმობს რომ შესაძლოა დავამუშაოთ თქვენს შესახებ ინფორმაცია
          პროგრამული უზრუნველყოფის მეშვეობით, რომელიც შეაფასებს თქვენს
          პერსონალურ ასპექტებს და წინასწარ განსაზღვრავს მოსალოდნელ რისკებსა და
          შესაძლო შედეგებს. <br />
          <br />
          ასევე შესაძლოა გამოვიყენოთ პროფილირება ან სხვაგვარად ჩავრთოთ
          ავტომატიზებული საშუალებები თქვენს შესახებ გადაწყვეტილების მისაღებად,
          რომლის საფუძველზეც გაწვდით დაზღვევის მომსახურებას. ამ შემთხვევაში
          სახეზეა „ავტომატიზებული ინდივიდუალური გადაწყვეტილების მიღება, რომელიც
          დასაშვებია მხოლოდ ამ ტიპის გადაწყვეტილების მისაღებად შესაბამისი
          საფუძვლის არსებობის შემთხვევაში. <br />
          <br />
          ჩვენ შეიძლება ამგვარი გადაწყვეტილებები მივიღოთ თქვენზე, როდესაც:{" "}
          <ul>
            <li>
              გადაწყვეტილებები საჭიროა ხელშეკრულების დასადებად. მაგალითად, ჩვენ
              შეიძლება მივიღოთ გადაწყვეტილება თქვენთვის მორგებული დაზღვევის
              ტიპების შესახებ, სადაზღვევო პრემიის გამოსათვლელად.{" "}
            </li>
            <li>
              ამგვარი გადაწყვეტილებები გათვალისწინებულია კანონით ან კანონის
              საფუძველზე დელეგირებული უფლებამოსილების ფარგლებში გამოცემული
              კანონქვემდებარე ნორმატიული აქტით.
            </li>
            <li>
              გვაძლევთ თანხმობას ავტომატიზებული ინდივიდუალური გადაწყვეტილების
              მისაღებად.{" "}
            </li>
          </ul>
          <br />
          <br />
          შეგიძლიათ დაგვიკავშირდეთ ავტომატიზებული ინდივიდუალური გადაწყვეტილების
          შესახებ დამატებითი ინფორმაციის მისაღებად. ასევე, უფლება გაქვთ უარი
          განაცხადოთ ან მოითხოვოთ ადამიანური რესურსის ჩართვა ავტომატიზებული
          ინდივიდუალური გადაწყვეტილების მიღების პროცესში.
        </div>

        <div className="mb-5">
          <h4 className="mb-2">თქვენი მონაცემების მიმღები პირები</h4>
          ჩვენ ვიღებთ ვალდებულებას დავიცვათ მიღებული ნებისმიერი სახის
          ინფორმაციის კონფიდენციალურობა და უსაფრთხოება. თუმცა, პერსონალური
          მონაცემების გადაცემა/გამჟღავნება მესამე პირებისთვის, შესაძლოა საჭირო
          გახდეს კანონმდებლობით პირდაპირ გათვალისწინებულ შეთხვევებში ან
          მომხმარებელთან გაფორმებული დაზღვევის ხელშეკრულებით გათვალისწინებულ
          ფარგლებში. აქედან გამომდინარე, ზოგიერთი კატეგორიის პერსონალური
          მონაცემების მიმღები შესაძლოა იყოს: <br />
          <br />
          <ul>
            <li>
              სამართალდამცავი ორგანოები ან სხვა პირი, ზარალის თავიდან აცილებისა
              ან/და მისი დარეგულირებისა და ანაზღაურების მიზნით, ასევე
              კანონმდებლობით განსაზღვრული საჯარო ინტერესის სფეროში შემავალი
              ამოცანების (მათ შორის, დანაშაულის აცილების, დანაშაულის გამოძიების,
              სისხლისსამართლებრივი დევნის, მართლმსაჯულების განხორციელების და
              ა.შ.) შესასრულებლად;
            </li>
            <li>
              ნებისმიერი ადგილობრივი სახელმწიფო ორგანიზაციები/სამსახურები,
              კანონმდებლობით განსაზღვრული მოთხოვნების შესრულების მიზნით;
            </li>
            <li>
              სხვა პირი (ფიზიკური ან იურიდიული), რომელიც თქვენს პერსონალურ
              მონაცემებს ამუშავებს კომპანიისთვის ან მისი სახელით, მხოლოდ იმ
              შემთხვევაში, თუ კომპანიას გაფორმებული აქვს დამუშავებაზე
              უფლებამოსილ პირთან შესაბამისი წერილობითი ხელშეკრულება.
              ხელშეკრულების გაფორმებამდე კომპანია ყოველთვის წინასწარ რწმუნდება
              მხარის სანდოობაში და ხელშეკრულებით ითვალისწინებს დამუშავებაზე
              უფლებამოსილი პირის ვალდებულებას, უზრუნველყოს ისეთი ორგანიზაციული
              და ტექნიკური ზომები, რაც დაიცავს თქვენს მონაცემებს, ხოლო
              ხელშეკრულების გაფორმების შემდეგ მონიტორინგს უწევს დამუშავებაზე
              უფლებამოსილი პირის მიერ მისი ვალდებულებების შესრულების პროცესს -
              მისი წარმომადგენლების მეშვეობით ამოწმებს დამუშავებაზე უფლებამოსილი
              პირის სამუშაო ადგილს, სადაც ხორციელდება თქვენი პერსონალური
              მონაცემების დამუშავება და ადგილზე ახორციელებს ინსპექტირებას
              მონაცემთა უსაფრთხოებისთვის გატარებული ღონისძიებების შემოწმების
              მიზნით. აღნიშნული ვალდებულებების დარღვევისთვის კომპანიასა და
              დამუშავებაზე უფლებამოსილ პირს შორის გაფორმებული ხელშეკრულებები
              ითვალისწინებს სანქციებს.
            </li>
          </ul>
        </div>

        <div className="mb-5">
          <h4 className="mb-2">მონაცემთა შენახვის ვადა</h4>
          მონაცემები შეინახება თქვენი მომსახურების მთელი პერიოდის განმავლობაში,
          იმ ვადით, რაც საჭიროა ზემოთ ჩამოთვლილი მიზნების მისაღწევად, მათ შორის,
          თქვენთან სადაზღვევო მომსახურების შეწყვეტის შემდგომაც, თუ ეს საჭიროა
          კანონმდებლობით გათვალისწინებული ვალდებულებების შესასრულებლად.
        </div>

        <div className="mb-5">
          <h4 className="mb-2">კონფიდენციალობის გარანტიები</h4>
          კომპანია უზრუნველვყოფს მოწოდებული ინფორმაციის მაქსიმალურ დაცულობას
          კანონმდებლობით დადგენილი წესით. ვჩვენ ზრუნავთ თქვენი ინფორმაციის
          უსაფრთხოებასა და კონფიდენციალურობაზე, თუმცა, ვიხსნით პასუხისმგებლობას
          მესამე პირების მიერ ინფორმაციის არასანქცირებულ წვდომაზე ამ მონაცემების
          კომპანიისთვის მოწოდების დროს (მათ შორის, ინფორმაციის დისტანციურად
          მოწოდებისას).
          <br />
          <br />
          თქვენ პასუხისმგებლობას იღებთ მოწოდებული ინფორმაციის სიზუსტეზე. თქვენი
          მონაცემების ცვლილებების შემთხვევაში, შეგიძლიათ გვაცნობოთ აღნიშნულის
          თაობაზე და შეძლებისდაგვარად მყისიერად, თუმცა, არაუგვიანეს 10 დღისა
          მოვახდენთ რეაგირებას და ავსახავთ ცვლილებებს შესაბამის მონაცემთა
          ბაზებში.
          <br />
          <br />
          კომპანია იღებს სათანადო უსაფრთხოების ზომებს, რათა დაიცვას მის
          კონტროლის ქვეშ არსებული მონაცემები არაუფლებამოსილი წვდომისგან, მათი
          უკანონო გამოყენებისგან და გამჟღავნებისგან, განადგურებისგან ან
          შემთხვევითი დაკარგვისგან.
          <br />
          <br />
          კომპანია უზრუნველვყოფს ასევე უსაფრთხოების სათანადო ზომებსა და
          პროცედურების არსებობას, მას გააჩნია დოკუმენტირებული ინფორმაციული
          უსაფრთხოების პროგრამა და ინფორმაციული უსაფრთხოების პოლიტიკა, სადაც
          განსაზღვრულია მმართველობითი, ტექნიკური, საოპერაციო და ფიზიკური
          უსაფრთხოების კონტროლის ღონისძიებები, რომლებიც შეგროვებული ინფორმაციისა
          და ჩვენი ბიზნესის თავისებურებების თანაბარზომიერია.
          <br />
          <br />
          ჩვენ გულისხმიერად ვეკიდებით თქვენი კონფიდენციალურობისა და მონაცემთა
          დაცვის უფლებებს და წინამდებარე პოლიტიკით განსაზღვრული შემთხვევების
          გარდა, თქვენ მონაცემებს გავამჟღავნებთ მხოლოდ იმ შემთხვევაში თუ ამას
          მოითხოვს კანონი, საზედამხედველო, მარეგულირებელი ან/და სამართალდამცავი
          ორგანოები, ან/და საკუთარი უფლებების ან სხვათა უფლებების დასაცავად და
          კანონმდებლობით გათვალისწინებულ სხვა შემთხვევებში.
        </div>
        <div className="mb-5">
          <h4 className="mb-2">თქვენი მონაცემთა დაცვის უფლებები</h4>
          თქვენ, გაქვთ შესაძლებლობა ისარგებლოთ კანონმდებლობით მონიჭებული ყველა
          უფლებამოსილებით. მათ შორის: <br />
          <br />
          <h6>მონაცემთა დამუშავების შესახებ ინფორმაციის მიღების უფლება</h6>
          თქვენ გაქვთ უფლება, ჩვენ და დამუშავებაზე უფლებამოსილ პირს მოსთხოვოთ
          იმის დადასტურება, მუშავდება თუ არა თქვენ შესახებ მონაცემები,
          დასაბუთებულია თუ არა 8 | 1 0 მონაცემთა დამუშავება და მოთხოვნის
          შესაბამისად უსასყიდლოდ მიიღოთ შემდეგი ინფორმაცია: თქვენ შესახებ იმ
          მონაცემის თაობაზე, რომელიც მუშავდება, აგრეთვე ამ მონაცემის დამუშავების
          საფუძვლისა და მიზნის შესახებ; მონაცემთა შეგროვების/მოპოვების წყაროს
          შესახებ; მონაცემთა შენახვის ვადის (დროის) შესახებ, ხოლო თუ კონკრეტული
          ვადის განსაზღვრა შეუძლებელია, ვადის განსაზღვრის კრიტერიუმების თაობაზე;
          მონაცემთა გადაცემის სამართლებრივი საფუძვლისა და მიზნების, აგრეთვე
          მონაცემთა დაცვის სათანადო გარანტიების შესახებ, თუ მონაცემები გადაეცემა
          სხვა სახელმწიფოს ან საერთაშორისო ორგანიზაციას; მონაცემთა მიმღების
          ვინაობის ან მონაცემთა მიმღებების კატეგორიების შესახებ, მათ შორის,
          ინფორმაცია მონაცემთა გადაცემის საფუძვლისა და მიზნის თაობაზე, თუ
          მონაცემები მესამე პირს გადაეცემა; ავტომატიზებული დამუშავების, მათ
          შორის, პროფაილინგის შედეგად მიღებული გადაწყვეტილების და იმ ლოგიკის
          შესახებ, რომელიც გამოიყენება ამგვარი გადაწყვეტილების მისაღებად,
          აგრეთვე მონაცემთა დამუშავებაზე მისი გავლენისა და დამუშავების
          მოსალოდნელი/სავარაუდო შედეგის თაობაზე.
          <br />
          <br />
          <h6>მონაცემთა გაცნობისა და ასლის მიღების უფლება</h6>
          თქვენ, როგორც მონაცემთა სუბიექტს უფლება გაქვთ, ჩვენთან და დამუშავებაზე
          უფლებამოსილ პირთან გაეცნოთ თქვენ შესახებ არსებულ პერსონალურ მონაცემებს
          და უსასყიდლოდ მიიღოთ ამ მონაცემების ასლები, გარდა კანონმდებლობით
          გათვალისწინებული გამონაკლისებისა
          <br />
          <br />
          <h6>მონაცემთა გასწორების, განახლებისა და შევსების უფლება</h6>
          თქვენ უფლება გაქვთ, ჩვენ და დამუშავებაზე უფლებამოსილ პირს მოგვთხოვოთ
          თქვენ შესახებ მცდარი, არაზუსტი ან/და არასრული მონაცემების გასწორება,
          განახლება ან/და შევსება.
          <br />
          <br />
          <h6>
            მონაცემთა დამუშავების შეწყვეტის, წაშლის ან განადგურების უფლება
          </h6>
          თქვენ უფლება გაქვთ, ჩვენ და დამუშავებაზე უფლებამოსილ პირს მოსთხოვოთ
          თქვენ შესახებ მონაცემთა დამუშავების (მათ შორის, პროფაილინგის)
          შეწყვეტა, წაშლა ან განადგურება.
          <br />
          <br />
          <h6>მონაცემთა დაბლოკვის უფლება</h6>
          თქვენ, როგორც მონაცემთა სუბიექტს უფლება გაქვთ, ჩვენ და დამუშავებაზე
          უფლებამოსილ პირს მოსთხოვოთ მონაცემთა დაბლოკვა, თუ არსებობს ერთ-ერთი
          შემდეგი გარემოება: სადავოდ ხდით მონაცემების ნამდვილობას ან სიზუსტეს;
          მონაცემთა დამუშავება უკანონოა, თუმცა ეწინააღმდეგებით მათ წაშლას და
          ითხოვს მონაცემთა დაბლოკვას; მონაცემები საჭირო აღარ არის მათი
          დამუშავების მიზნის მისაღწევად, თუმცა თქვენ ისინი გჭირდებათ
          საჩივრის/სარჩელის წარსადგენად; თქვენ მოითხოვეთ მონაცემთა დამუშავების
          შეწყვეტა, წაშლა ან განადგურება და მიმდინარეობს ამ მოთხოვნის განხილვა;
          არსებობს მონაცემების მტკიცებულებად გამოყენების მიზნით შენახვის
          აუცილებლობა.
          <br />
          <br />
          <h6>მონაცემთა გადატანის უფლება</h6>
          კანონმდებლობით გათვალისწინებული საფუძვლებით მონაცემთა ავტომატური
          დამუშავების შემთხვევაში, თუ ეს ჩვენი მხრიდან ტექნიკურად შესაძლებელია,
          უფლება გაქვთ, ჩვენგან და დამუშავებაზე უფლებამოსილი პირისგან
          სტრუქტურიზებული, საზოგადოდ გამოყენებადი და მანქანურად წაკითხვადი
          ფორმატით მიიღოთ თქვენ მიერ მოწოდებული მონაცემები ან მოითხოვოთ ამ
          მონაცემთა სხვა დამუშავებისთვის პასუხისმგებელი პირისთვის გადაცემა.
          <br />
          <br />
          <h6>
            ავტომატიზებული ინდივიდუალური გადაწყვეტილების მიღება და მასთან
            დაკავშირებული უფლებები
          </h6>
          თქვენ უფლება გაქვთ, არ დაექვემდებაროთ მხოლოდ ავტომატიზებულად, მათ
          შორის, პროფაილინგის საფუძველზე, მიღებულ გადაწყვეტილებას, რომელიც
          თქვენთვის წარმოშობს სამართლებრივ ან სხვა სახის არსებითი მნიშვნელობის
          მქონე შედეგს, გარდა კანონმდებლობით გათვალისწინებული შემთხვევებისა.
          <br />
          <br />
          <h6>თანხმობის გამოხმობის უფლება</h6>
          თქვენ უფლება გაქვთ, ნებისმიერ დროს, ყოველგვარი განმარტების ან
          დასაბუთების გარეშე გამოიხმოთ თქვენ მიერ გაცემული თანხმობა პერსონალური
          მონაცემების დამუშავების თაობაზე. ამ შემთხვევაში, თქვენი მოთხოვნის
          შესაბამისად, ჩვენ შევწყვეტთ მონაცემთა დამუშავებას ან/და წავშლით ან
          გავანადგურებთ დამუშავებულ მონაცემებს კანონმდებლობით დადგენილ ვადებში,
          თუ მონაცემთა დამუშავების სხვა საფუძველი არ იარსებებს. <br />
          <br />
          თქვენ უფლება გაქვთ, თანხმობა გამოიხმოთ იმავე ფორმით, რომლითაც თანხმობა
          განაცხადეთ. ამასთან, ამასთან აღნიშნულის განხორციელება ასევე შეგიძლიათ
          ჩვენს იურიდიულ მისამართზე წერილობითი შეტყობინების გამოგზავნის, ჩვენს
          ტელეფონის ნომერზე: (<a href="tel:2922222">2 92 22 22</a>)
          დაკავშირებით, ჩვენს ელექტრონულ მისამართზე:
          <a href="mailto:personaldataofficer@imedil.ge">
            personaldataofficer@imedil.ge
          </a>{" "}
          ელექტრონული შეტყობინების გამოგზავნის ან ჩვენს ნებისმიერ ოფისში
          მოთხოვნის გაცხადების გზით. თქვენ უფლება გაქვთ თანხმობის გამოხმობამდე
          მოგვთხოვოთ და მიიღოთ ინფორმაცია თანხმობის გამოხმობის შესაძლო შედეგების
          შესახებ.
          <br />
          <br />
          გთხოვთ გაითვალისწინოთ, რომ ზემოაღნიშნული უფლებების რეალიზებისთვის ჩვენ
          მოვახედენთ თქვენს იდენტიფიკაციას, რათა დავრწმუნდეთ, რომ პერსონალური
          მონაცემების შემცველი ინფორმაცია მიეწოდება მონაცემთა სუბიექტს ან
          ამისთვის სათანადოდ უფლებამოსილ პირს.
          <br />
          <br />
          <h6>გასაჩივრების უფლება</h6>
          თქვენ უფლება გაქვთ, „პერსონალურ მონაცემთა დაცვის შესახებ“ საქართველოს
          კანონმდებლობით დადგენილი უფლებებისა და წესების დარღვევის შემთხვევაში
          კანონით დადგენილი წესით მიმართოთ პერსონალურ მონაცემთა დაცვის
          სამსახურს, სასამართლოს ან/და ზემდგომ ადმინისტრაციულ ორგანოს. ამასთან,
          ჩვენი ქმედების გასაჩივრების უფლებამოსილება გაქვთ ჩვენს ოფიციალურ
          ელექტრონულ მისამართზე:{" "}
          <a href="mailto:personaldataofficer@imedil.ge">
            personaldataofficer@imedil.ge
          </a>{" "}
          -ზე.
          <br />
          <br />
          <h6>
            {" "}
            პირდაპირი მარკეტინგის მიზნით გაცხადებული თანხმობის გამოხმობის უფლება
          </h6>
          თქვენ ასევე გაქვთ უფლება გამოიხმოთ პირდაპირი მარკეტინგის მიზნით
          გაცხადებული თანხმობა ნებისმიერ დროს, ყოველგვარი საფასურის გადახდის
          გარეშე იმავე ფორმით, რომლითაც პირდაპირი მარკეტინგი ხორციელდება თქვენ
          მიმართ. ასევე, საჭიროების შემთხვევაში, თანხმობის გამოხმობის უფლება
          გაქვთ ჩვენს ტელეფონის ნომერზე{" "}
          <a href="tel:+995322922222">+995 322 922 222</a> დარეკვის, ჩვენს
          ელექტრონულ მისამართზე:{" "}
          <a href="mailto:personaldataofficer@imedil.ge">
            personaldataofficer@imedil.ge
          </a>{" "}
          ელექტრონული შეტყობინების გამოგზავნის ან ჩვენს ნებისმიერ ოფისში
          მოთხოვნის გაცხადების გზით.
          <br />
          <br />
          ზემოაღნიშნული უფლებები არააბსოლუტურია და შესაძლოა შეიზღუდოს
          კანონმდებლობით გათვალისწინებულ შემთხვევებში.
        </div>

        <div className="mb-5">
          <h4 className="mb-2">ცვლილებები მონაცემთა დაცვის პოლიტიკაში</h4>
          უფლებას ვიტოვებთ ნებისმიერ დროს განვაახლოთ პოლიტიკა. თქვენი
          პერსონალური მონაცემების დამუშავებაში ან პოლიტიკის არსებითი ცვლილებების
          შემთხვევაში, გექნებათ საშუალება გაეცნოთ შეცვლილ პირობებს. ეს პოლიტიკა
          ვრცელდება ყველა ინფორმაციაზე, რომელსაც ვებგვერდის მეშვეობით ვამუშავებთ
          თქვენს შესახებ
        </div>
      </div>
    </div>
  );
};

export default PrivacyStatement;
